export const columnData = [
  { name: 'Código', widthCol: '10%', label: 'Id' },
  { name: 'Fecha', widthCol: '45%', label: 'Date' },
  { name: 'Valor', widthCol: '40%', label: 'Value' },
  { name: 'Editar', widthCol: '5%', label: 'Edit' }
]
